import {
    PortfolioRateGroupOverview,
    PortfolioRateGroupOverviewFilters,
    useRepositoryQuery,
} from '@mews-commander/data-access';
import { TableState } from '@optimus-web/core';

export const useRateGroups = (enterpriseIds: string[], options?: { enabled?: boolean }) =>
    useRepositoryQuery('rateGroups', 'getAll', { enterpriseIds }, { enabled: options?.enabled ?? true });

export const usePortfolioRateGroupOverview = (
    tableState: TableState<PortfolioRateGroupOverview, PortfolioRateGroupOverviewFilters>
) =>
    useRepositoryQuery('portfolioRateGroups', 'getOverview', {
        pagination: tableState.pagination,
        filters: tableState.filters,
        sort: tableState.sort,
    });
